import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useMemoizedFn } from 'ahooks';
import { isSufeExamClient } from '@/utils/examClient';
import store, { useAppSelector } from '@/stores';
import { getExamInfoAsync } from '@/stores/slice/exam';
import { getStudentInfoAsync } from '@/stores/slice/user';
import i18n from '@/locales/init';
import style from './index.module.less';
import OneTest from './OneTest';
import Introduction from './Introduction/index';



type keyType2 = 'listening' | 'reading' | 'writing'

function MockStart() {

  const params = useParams<{recordId: string;}>();
  const {recordId} = params;
  const navigate = useNavigate();


  const data = useAppSelector((state) => state.exam.info);
  const recordData = data?.record_id === Number(recordId) ? data : undefined;
  const type = data?.type;
  const targetInfo = useAppSelector((state) => state.user.targetScore);
  const userId = useAppSelector((state) => state.user.userId);

  useEffect(() => {
    store.dispatch(getExamInfoAsync({record_id: Number(recordId)}));
    store.dispatch(getStudentInfoAsync());
  }, [recordId]);

  const enableObj = useMemo(() => {
    const obj = {
      listening: false,
      reading: false,
      writing: false
    };
    if (type === 2) {
      obj.listening = true;
    } else if (type === 3) {
      obj.reading = true;
    } else if (type === 4) {
      obj.writing = true;
    } else {
      ['listening','reading','writing'].find((key) => {
        if (data && (data[key as keyType2].status === 1 || data[key as keyType2].status === 2)) {
          obj[key as keyType2] = true;
          return true;
        }
        return false;
      });
    }
    return obj;
  }, [data]);

  const examFinished = useMemo(() => {
    const listeningFinshed = recordData?.listening.status === 4;
    const writingFinished = recordData?.writing.status === 4
      || (recordData?.writing.status === 3 && recordData.writing.submission_pending === false);
    const readingFinished = recordData?.reading.status === 4;

    switch (recordData?.type) {
      case 1: return listeningFinshed && writingFinished && readingFinished;
      case 2: return !!listeningFinshed;
      case 3: return !!readingFinished;
      case 4: return !!writingFinished;
      default: return false;
    }

  }, [recordData]);

  const writingSubmissionPending = recordData?.type === 1
    && recordData.listening.status === 4
    && recordData.reading.status === 4
    && recordData.writing.status === 3
    && recordData.writing.submission_pending === true;

  const writingSubmissionUnresolved = recordData?.type === 1
    && recordData.listening.status === 4
    && recordData.reading.status === 4
    && recordData.writing.status === 3
    && recordData.writing.submission_pending !== false;

  useEffect(() => {
    if (isSufeExamClient() && writingSubmissionPending && recordId) {
      navigate(`/mockwriting/${recordId}`, {replace: true});
    }
  }, [navigate, recordId, writingSubmissionPending]);



  const updateWritingScore = useMemoizedFn(() => {
    if (data?.writing.status === 3) {
      store.dispatch(getExamInfoAsync({record_id: Number(recordId)}));
    }
  });

  useEffect(() => {
    setTimeout(() => {
      updateWritingScore();
    }, 1000 * 20);
  }, [data]);

  const arr = [['listening', 'Listening'], ['reading', 'Reading'], ['writing','Writing']] as const;
  const videoMap = useMemo(() => ({
    listening: 'https://duy-ielts-public.oss-cn-hangzhou.aliyuncs.com/front/mock_test/listening.mp4',
    reading: 'https://duy-ielts-public.oss-cn-hangzhou.aliyuncs.com/front/mock_test/reading.mp4',
    writing: 'https://duy-ielts-public.oss-cn-hangzhou.aliyuncs.com/front/mock_test/writing.mp4'
  }), []);


  const timeMap = useMemo(() => ({
    Listening: '30',
    Reading: '60',
    Writing: '60'
  }), []);

  return (
    <div className={style.dashboard}>
      <div className={style.topBar}>
        <div className={style.info}>
          <div className={style.studentId}>{i18n.t('common.dauyan_zkn_xxxxxx', { user_id: userId })}</div>
        </div>
        {isSufeExamClient() && !writingSubmissionUnresolved && (
          <button type="button" className={style.exit} onClick={() => window.close()}>{i18n.t('common.dauyan_exit_to_home')}</button>
        )}
      </div>
      <div className={style.container}>
        <div className={style.row}>
          <h1 className={style.h1}>IELTS Familiarisation Test</h1>
        </div>
        <div className={style.date}>
          <p className={style.dateTxt}>Today</p>
          <hr className={style.horizontalLine}/>
        </div>
        {
          arr.map((strArr) => {
            const [keyLowerCase, key] = strArr;
            const videoUrl = videoMap[keyLowerCase];
            return (data?.[keyLowerCase] ? <OneTest {...data[keyLowerCase]} title={key} key={key} enable={enableObj[keyLowerCase]} videoUrl={videoUrl} time={timeMap[key]} recordId={recordId as string} target={targetInfo[keyLowerCase]} showScore={examFinished}></OneTest> : null);
          })
        }
      </div>
      <div className={style.footer}>
        <span className={style.footerItem}>{i18n.t('common.dauyan_website_recorde_code')}</span>
        <span className={style.footerItem}>{i18n.t('common.dauyan_shenzhendauyan', { year: new Date().getFullYear() })}</span>
        <span className={style.footerItem}>{i18n.t('common.dauyan_phone')}</span>
      </div>
      <Introduction></Introduction>
    </div>
  );
}

export default MockStart;
